import { SplashScreen } from 'expo-router'
import { useEffect, useRef } from 'react'

export function useHideSplashOnLoad(loaded: boolean) {
    const hasHidden = useRef(false)

    useEffect(() => {
        if (!loaded) return

        if (hasHidden.current) return

        SplashScreen.hideAsync().catch(() => {})
        hasHidden.current = true
    }, [loaded])
}
